<section [class.open]="display" class="fixed z-50 inset-0" (click)="close()">
    <div class="flex items-center h-screen w-full text-center bg-gray-900 bg-opacity-40" [ngClass]="componentname === 'CartModalComponent' ? 'justify-end' : 'justify-end md:justify-center'">
        <div (click)="$event.stopPropagation()" class="bg-white text-left overflow-hidden shadow-xl transform transition-all contents" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div  [ngClass]="componentname === 'PopUpInformationComponent' ? 'popUp mx-6 max-w-screen-md' : 'h-screen md:h-full max-w-md'" class="rounded-md bg-white w-full items-start flex flex-col">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</section>